/**
 * 管理メニュー内の「AIアシスタント設定」ページ。
 * 旧・独立の「設定」ボタンは廃止し、FAST 由来の管理メニューに統合した（山本さん指示 2026-06-12）。
 * 記憶と顔・改名・再インタビュー・中断（ここまでにする）は既存の AgentSettingsDialog をそのまま
 * 流用（ロジックは1箇所＝Settings.tsx）。ここはそれを管理画面に載せる薄いラッパ。
 */
import { useCallback, useEffect, useState } from "react"
import { useAuth } from "@/hooks/useAuth"
import { AgentSettingsDialog } from "@/components/settings/Settings"
import { AgentProfile, getAvatarUrl, getProfile } from "@/services/boardService"

export default function AgentSettings() {
  const { user } = useAuth()
  const idToken = user?.id_token || ""
  const [profile, setProfile] = useState<AgentProfile | null>(null)
  const [avatarUrl, setAvatarUrl] = useState("")

  const loadProfile = useCallback(async () => {
    if (!idToken) return
    try {
      const p = await getProfile(idToken)
      setProfile(p)
      if (p.avatar === "image") {
        try {
          setAvatarUrl((await getAvatarUrl(idToken)).url)
        } catch {
          /* no image */
        }
      }
    } catch {
      setProfile({ agentName: "", nameOrigin: "", icon: "", avatar: "svg", avatarVer: "", memory: [] })
    }
  }, [idToken])

  useEffect(() => {
    loadProfile()
  }, [loadProfile])

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-1">AIアシスタント設定</h1>
      <p className="text-sm text-muted-foreground mb-4">
        アシスタントの名前・顔・特に覚えてほしいことを管理します。再インタビューで覚え直してもらうこともできます。
      </p>
      {idToken && profile !== null && (
        <AgentSettingsDialog
          idToken={idToken}
          profile={profile}
          avatarUrl={avatarUrl}
          tutorial={!profile.agentName}
          asPage
          // フルページ表示。保存・読込は現行どおり（各操作が即時 saveProfile）。
          // 閉じる導線は無く、画面として常駐する。再読込でプロフィール表示を同期。
          onClose={loadProfile}
        />
      )}
    </div>
  )
}
